import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { catchError, NEVER, of, tap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TablePayload, User } from '../../models/users';
import { UsersExportService } from '../../services/users-export.service';
import { saveAs } from 'file-saver';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-excel-export',
  standalone: true,
  templateUrl: './excel-export.component.html',
  imports: [MatButton, MatIcon, MatProgressSpinner, AsyncPipe],
  styleUrl: './excel-export.component.scss'
})
export class ExcelExportComponent implements OnInit {
  @Input() selectedUsers: User[] = [];
  @Input() pageConfig!: Partial<TablePayload> | null;
  downloading = false;
  exportingProgress$ = of(0);

  private destroyRef = inject(DestroyRef);
  private matSnackBar = inject(MatSnackBar);
  private usersExportService = inject(UsersExportService);

  ngOnInit() {
    this.exportingProgress$ = this.usersExportService.getExportProgress();
  }

  export() {
    if (!this.downloading) {
      this.downloading = true;
      this.matSnackBar.open('File export is in progress', 'x', { panelClass: 'snackbar-green' });
      this.handleExport();
    }
  }

  private handleExport() {
    const selectedIds = this.selectedUsers.map(({ id }) => id);
    this.usersExportService
      .exportExcel(this.pageConfig!, selectedIds)
      .pipe(
        tap(file => {
          saveAs(file, 'users.xlsx');
          this.downloading = false;
        }),
        catchError(error => {
          console.error(error);
          this.matSnackBar.open('Could not download the file. Please try again later', 'x');
          this.downloading = false;

          return NEVER;
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
